export default __webpack_public_path__ + "static/media/favs.99d7da52.png";